import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import Marquee from 'react-fast-marquee'
import StarRating from '~/components/StarRating'

import { breakpoints } from '../../utils/styles'

const ReviewsScroller = props => {
  const reviews = [
    { title: "Best vegan snack I've ever tried", name: 'Maddalena, Devon' },
    { title: 'Best tasting<br />beneficial treat', name: 'Jo Hemmings, Lancs' },
    { title: 'Added benefits of CBD and nootropics.', name: 'Dave, London' },
    {
      title: 'Great afternoon substitute to coffee',
      name: 'Heather, Lincoln',
    },
    { title: 'Very flavoursome and smell great', name: 'Dorian, London' },
    { title: 'The perfect energy snack', name: 'Alora, Highgate' },
    { title: 'Excellent customer service', name: 'Kayley, Manchester' },
  ]

  useEffect(() => {
    const feefoScript = document.createElement('script')
    feefoScript.setAttribute('async', 'async')
    feefoScript.setAttribute('id', 'feefo-script')
    feefoScript.setAttribute(
      'src',
      'https://api.feefo.com/api/javascript/nooro'
    )
    feefoScript.setAttribute('type', 'text/javascript')
    setTimeout(() => {
      document.body.appendChild(feefoScript)
    }, 0)

    return () => {
      const feefoScript = document.querySelector('#feefo-script')
      if (feefoScript) {
        feefoScript.remove()
      }
    }
  }, [])

  return (
    <>
      <Wrapper {...props}>
        <Marquee gradient={false} speed={20} direction="left">
          {reviews.map((review, i) => {
            return (
              <Review key={`review-${i}`}>
                <div>
                  <RatingWrapper>
                    <StarRating fill="#ffcb2c" />
                  </RatingWrapper>
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: `"${review.title}"`,
                    }}
                  />
                  <span style={{ marginTop: 10, display: 'block' }}>
                    {review.name}
                  </span>
                </div>
              </Review>
            )
          })}
        </Marquee>
      </Wrapper>
    </>
  )
}

export default ReviewsScroller

export const Wrapper = styled.div`
  padding: 33px 0;
  color: #211f15;
  background: #fdf3e3;
  text-align: center;

  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0;
  }
`

export const RatingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export const Review = styled.div`
  width: 300px;
  padding: 30px;
  margin: 0 20px;
  display: flex;
  font-family: 'SohneBreit';
  line-height: 1.6;
  justify-content: center;
  text-align: center;

  span {
    font-size: 80%;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 0;
    width: 200px;
  }
`

export const Text = styled.div`
  font-weight: 700;
  font-size: 1.5em;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }
`
